export default "__VITE_ASSET__8d82465c__"